import React, { useState } from 'react';
import { API_URL } from '../../utils/constants';
import { styles } from './styles';

function CustomerTab({ formData, setFormData, token }) {
  const [isSaving, setIsSaving] = useState(false);
  const [saveMessage, setSaveMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // 사업자등록번호 자동 포맷 (000-00-00000)
    if (name === 'businessNumber') {
      const cleaned = value.replace(/\D/g, '');
      let formatted = cleaned;
      if (cleaned.length <= 3) {
        formatted = cleaned;
      } else if (cleaned.length <= 5) {
        formatted = `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
      } else if (cleaned.length <= 10) {
        formatted = `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(5, 10)}`;
      }
      setFormData(prev => ({ ...prev, [name]: formatted }));
      return;
    }

    // 전화번호 포맷
    if (name === 'phone' || name === 'mobile') {
      const cleaned = value.replace(/\D/g, '');
      let formatted = cleaned;

      if (name === 'mobile' && cleaned.startsWith('01')) {
        if (cleaned.length <= 3) {
          formatted = cleaned;
        } else if (cleaned.length <= 7) {
          formatted = `${cleaned.slice(0,3)}-${cleaned.slice(3)}`;
        } else if (cleaned.length <= 11) {
          formatted = `${cleaned.slice(0,3)}-${cleaned.slice(3,7)}-${cleaned.slice(7,11)}`;
        }
      } else if (name === 'phone') {
        if (cleaned.startsWith('02')) {
          if (cleaned.length <= 2) {
            formatted = cleaned;
          } else if (cleaned.length <= 5) {
            formatted = `${cleaned.slice(0,2)}-${cleaned.slice(2)}`;
          } else if (cleaned.length <= 9) {
            formatted = `${cleaned.slice(0,2)}-${cleaned.slice(2,5)}-${cleaned.slice(5,9)}`;
          } else if (cleaned.length <= 10) {
            formatted = `${cleaned.slice(0,2)}-${cleaned.slice(2,6)}-${cleaned.slice(6,10)}`;
          }
        } else if (cleaned.startsWith('0')) {
          if (cleaned.length <= 3) {
            formatted = cleaned;
          } else if (cleaned.length <= 6) {
            formatted = `${cleaned.slice(0,3)}-${cleaned.slice(3)}`;
          } else if (cleaned.length <= 10) {
            formatted = `${cleaned.slice(0,3)}-${cleaned.slice(3,6)}-${cleaned.slice(6,10)}`;
          } else if (cleaned.length <= 11) {
            formatted = `${cleaned.slice(0,3)}-${cleaned.slice(3,7)}-${cleaned.slice(7,11)}`;
          }
        }
      }

      setFormData(prev => ({ ...prev, [name]: formatted }));
      return;
    }

    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSaveCustomer = async () => {
    if (isSaving) return;

    setIsSaving(true);
    setSaveMessage('');

    try {
      const response = await fetch(`${API_URL}/customers/${formData.customerId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          companyName: formData.companyName,
          phone: formData.phone,
          manager: formData.manager,
          mobile: formData.mobile,
          address: formData.address,
          businessNumber: formData.businessNumber,
          representative: formData.representative,
          businessType: formData.businessType,
          businessCategory: formData.businessCategory,
          email: formData.email
        })
      });

      if (response.ok) {
        setSaveMessage('저장되었습니다.');
        setTimeout(() => setSaveMessage(''), 3000);
      } else {
        setSaveMessage('저장 실패');
      }
    } catch (error) {
      console.error('고객 정보 저장 오류:', error);
      setSaveMessage('저장 중 오류 발생');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div style={styles.fadeIn}>
      {/* 기본 정보 섹션 */}
      <div style={styles.formSection}>
        <h4 style={styles.sectionTitle}>기본 정보</h4>
        <div style={{ ...styles.formGrid, gridTemplateColumns: 'repeat(2, 1fr)' }}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>업체명 *</label>
            <input
              type="text"
              name="companyName"
              value={formData.companyName || ''}
              onChange={handleInputChange}
              style={styles.input}
              placeholder="업체명을 입력하세요"
            />
          </div>
          <div style={styles.inputGroup}>
            <label style={styles.label}>대표자명</label>
            <input
              type="text"
              name="representative"
              value={formData.representative || ''}
              onChange={handleInputChange}
              style={styles.input}
              placeholder="대표자명을 입력하세요"
            />
          </div>
          <div style={styles.inputGroup}>
            <label style={styles.label}>담당자</label>
            <input
              type="text"
              name="manager"
              value={formData.manager || ''}
              onChange={handleInputChange}
              style={styles.input}
              placeholder="담당자를 입력하세요"
            />
          </div>
          <div style={styles.inputGroup}>
            <label style={styles.label}>사업자등록번호</label>
            <input
              type="text"
              name="businessNumber"
              value={formData.businessNumber || ''}
              onChange={handleInputChange}
              style={styles.input}
              placeholder="000-00-00000"
              maxLength={12}
            />
          </div>
        </div>
      </div>

      {/* 연락처 섹션 */}
      <div style={styles.formSection}>
        <h4 style={styles.sectionTitle}>연락처</h4>
        <div style={{ ...styles.formGrid, gridTemplateColumns: 'repeat(3, 1fr)' }}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>전화번호</label>
            <input
              type="text"
              name="phone"
              value={formData.phone || ''}
              onChange={handleInputChange}
              style={styles.input}
              placeholder="02-0000-0000"
            />
          </div>
          <div style={styles.inputGroup}>
            <label style={styles.label}>휴대폰</label>
            <input
              type="text"
              name="mobile"
              value={formData.mobile || ''}
              onChange={handleInputChange}
              style={styles.input}
              placeholder="010-0000-0000"
            />
          </div>
          <div style={styles.inputGroup}>
            <label style={styles.label}>이메일</label>
            <input
              type="email"
              name="email"
              value={formData.email || ''}
              onChange={handleInputChange}
              style={styles.input}
              placeholder="example@email.com"
            />
          </div>
        </div>
      </div>

      {/* 사업자 정보 섹션 */}
      <div style={styles.formSection}>
        <h4 style={styles.sectionTitle}>사업자 정보 (세금계산서용)</h4>
        <div style={{ ...styles.formGrid, gridTemplateColumns: 'repeat(2, 1fr)' }}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>업태</label>
            <input
              type="text"
              name="businessType"
              value={formData.businessType || ''}
              onChange={handleInputChange}
              style={styles.input}
              placeholder="예: 서비스업, 제조업"
            />
          </div>
          <div style={styles.inputGroup}>
            <label style={styles.label}>종목</label>
            <input
              type="text"
              name="businessCategory"
              value={formData.businessCategory || ''}
              onChange={handleInputChange}
              style={styles.input}
              placeholder="예: 컴퓨터수리, 소프트웨어개발"
            />
          </div>
        </div>
        <div style={{ ...styles.formGrid, gridTemplateColumns: '1fr', marginTop: '12px' }}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>주소</label>
            <input
              type="text"
              name="address"
              value={formData.address || ''}
              onChange={handleInputChange}
              style={styles.input}
              placeholder="사업장 주소를 입력하세요"
            />
          </div>
        </div>
      </div>

      {/* 저장 버튼 */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '16px', marginTop: '20px' }}>
        <button
          onClick={handleSaveCustomer}
          style={{
            ...styles.addButton,
            ...(isSaving ? styles.addButtonDisabled : {}),
            minWidth: '200px'
          }}
          disabled={isSaving}
        >
          {isSaving ? '저장 중...' : '고객 정보 저장'}
        </button>
        {saveMessage && (
          <span style={{
            color: saveMessage === '저장되었습니다.' ? '#27ae60' : '#e74c3c',
            fontWeight: '600'
          }}>
            {saveMessage}
          </span>
        )}
      </div>
    </div>
  );
}

export default CustomerTab;
